// src/components/Navbar.jsx
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Navbar() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="navbar">
      <Link to="/dashboard" className="navbar-brand">
        eBook Library
      </Link>
      <nav className="navbar-links">
        {isAuthenticated && (
          <>
            <NavLink to="/dashboard" className="nav-link">
              Dashboard
            </NavLink>
            <NavLink to="/search" className="nav-link">
              Search
            </NavLink>
            <NavLink to="/upload" className="nav-link">
              Upload
            </NavLink>
          </>
        )}
      </nav>
      <div className="navbar-auth">
        {isAuthenticated ? (
          <button className="btn btn-secondary" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <NavLink to="/login" className="btn btn-primary">
            Login
          </NavLink>
        )}
      </div>
    </header>
  );
}